import React, { forwardRef } from 'react';
import type { SliderProps } from '@mui/material';
import { Slider as SliderMUI } from '@mui/material';

import { SHAPE_CIRCULAR } from '@/mui/constants';

import type { ShapeProp } from '@/mui/types';

import { omitUndefinedProps } from '../../helpers';

import { CUSTOM_ATTRIBUTE_READONLY, CUSTOM_ATTRIBUTE_SHAPE } from './Slider.api';

type Props = {
  size?: SliderProps['size'];
  shape?: ShapeProp;
  readOnly?: boolean;
};

const Slider = forwardRef<HTMLSpanElement, SliderProps & Props>((props, ref) => (
  <SliderMUI
    {...omitUndefinedProps({
      ...props,
      size: props.size ?? 'medium',
      shape: undefined,
      readOnly: undefined,
      [CUSTOM_ATTRIBUTE_SHAPE]: props.shape ?? SHAPE_CIRCULAR,
      [CUSTOM_ATTRIBUTE_READONLY]: props.readOnly ? '' : undefined,
    })}
    ref={ref}
  />
));

Slider.displayName = 'Slider';

export default Slider;
